import React, { PropsWithChildren } from 'react'
import FeatureFlagsContext, {
  RegisteredFeatureFlags,
  useFeatureFlagsContext
} from './context'
import type { State } from './models'
import { useSelector } from 'react-redux'
import * as CommonSelectors from '@src/selectors'
import {
  getFeatureFlags,
  RegistredFeatureflag
} from '@src/endpoints/feature.flag'
import { keys } from 'lodash'
import { setPending } from './helpers'
import Spinner from '@src/components/common/loader'

export interface FeatureFlagsServiceProps {}

export const FeatureFlagsContainer: React.FC<PropsWithChildren<{}>> =
  React.memo(({ children }: PropsWithChildren<{}>) => {
    const { pending } = useFeatureFlagsContext()
    return <>{!pending ? children : <Spinner loading={pending} />}</>
  })

const FeatureFlagsService: React.FC<FeatureFlagsServiceProps> = ({
  children
}: PropsWithChildren<FeatureFlagsServiceProps>) => {
  const [state, setState] = React.useState<State>({
    flags: RegisteredFeatureFlags,
    pending: true
  })

  const isLoggedIn = useSelector(CommonSelectors.isLoggedIn)

  React.useEffect(() => {
    if (isLoggedIn) {
      const registeredFFlagsNames = keys(RegisteredFeatureFlags || {}) || []
      setState(prev => setPending(prev, true))
      getFeatureFlags(registeredFFlagsNames as RegistredFeatureflag[], {
        signal: null
      }).then(fFlags => {
        setState(prev => ({
          ...setPending(
            {
              ...prev,
              flags: { ...(prev?.flags || RegisteredFeatureFlags), ...fFlags }
            },
            false
          )
        }))
      })
    }
  }, [isLoggedIn])

  return (
    <FeatureFlagsContext.Provider
      value={{ ...state?.flags, pending: state?.pending }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export default FeatureFlagsService
